import {isArray, isEqual, sortBy} from 'lodash';
import {FilterKeys, Filters} from '@utils/pageConfig/Types';

export const checkIsFilterApplied = (appliedFilters: Filters[], savedFilters: Filters[]) => {
  // Return false if either appliedFilters or savedFilters is falsy or not an array
  if (!appliedFilters || !savedFilters || !isArray(appliedFilters) || !isArray(savedFilters)) return false;

  // Return false if either of the arrays is empty
  if (appliedFilters.length === 0 || savedFilters.length === 0) return false;

  // Strictly compare sizes
  if (appliedFilters.length !== savedFilters.length) return false;

  // Sort both filters by `filterKey`
  const sortedAppliedFilters = sortBy(appliedFilters, 'filterKey');
  const sortedSavedFilters = sortBy(savedFilters, 'filterKey');

  // Compare each filter
  return sortedSavedFilters.every((savedFilter, index) => {
    const appliedFilter = sortedAppliedFilters[index];

    // Ensure `filterKey` matches and the applied filter exists
    if (!appliedFilter || appliedFilter.filterKey !== savedFilter.filterKey) return false;

    // Sort options within each filter before comparing
    const sortedSavedOptions = savedFilter.filterKey === FilterKeys.PRICEBAND ? sortBy(savedFilter.options, 'value') : sortBy(savedFilter.options, 'label');
    const sortedAppliedOptions = appliedFilter.filterKey === FilterKeys.PRICEBAND ? sortBy(appliedFilter.options, 'value') : sortBy(appliedFilter.options, 'label');

    return isEqual(sortedSavedOptions, sortedAppliedOptions);
  });
};
